export default __webpack_public_path__ + "static/media/no-coloured-organization.d092c3a5.svg";